"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarriers = void 0;
const use_carriers_hook_1 = require("./use-carriers/use-carriers.hook");
Object.defineProperty(exports, "useCarriers", { enumerable: true, get: function () { return use_carriers_hook_1.useCarriers; } });
